/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useSyncExternalStore } from 'react';
import { useTranslation } from "react-i18next";
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Button, Stack, Paper, Typography, Divider, Grid, Box, IconButton } from '@mui/material';
import { Formik } from 'formik';
import { LoadingButton } from "@mui/lab";
import moment from "moment";
import Question from '../../../components/form/Question';
import ReplayIcon from '@mui/icons-material/Replay';
import { LocalGasStation, Speed } from '@mui/icons-material';
import SaveIcon from '@mui/icons-material/Save';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem
} from "@radix-ui/react-dropdown-menu";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

import find from "lodash/find";
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import FilesModal from "./FilesModal";
import { calculateKilometers} from '../../../config/hook/calculateKilometer';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import InputText from "../../../components/form/InputText";
import InputTextDetail from "../../../components/form/InputTextDetail";
import InputGroup from '../../../components/form/inputGroupDetail';
import DatePickerUi from "../../../components/form/DatePickerUi";
import validator from "./validator"
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Skeleton from "../../../components/form/Skeleton"
import Map from "../../../components/map/MapMany2";
import Graf from "./Graf";
import RoutesModal from "./RoutesModal";
import TransportModal from './TransportModal';
import DriverModal from './DriverModal';
import Autocomplete from '../../../components/form/AutoComplete';
import LogsModal from "./LogsModal";
import HistoryIcon from '@mui/icons-material/History';
import { getLog } from "../../../store/config/thunk/log/getAll";
import MissingTariffAlert from '../../../components/form/MissingTariffAlert ';

import { getFuel } from "../../../store/masters/thunk/fuel/getAll";
import { getRouteId, clearStatus } from "../../../store/transactions/thunk/route/getId";
import { getDeliveryPointRoute } from "../../../store/transactions/thunk/deliveyPointRoute/getAll";
import { getDriver } from "../../../store/masters/thunk/driver/getAll";
import { getDriverClear } from "../../../store/masters/actions/driver/getAll";
import { getTransport } from "../../../store/masters/thunk/transport/getAll";
import { putRoute } from "../../../store/transactions/thunk/route/put";
import { putRouteStatus } from "../../../store/transactions/thunk/route/putStatusRoute";
import { putRouteStatusFinish } from "../../../store/transactions/thunk/route/putStatusFinishRoute";
import { putRouteStatusFakeShipping } from "../../../store/transactions/thunk/route/putStatusFakeShippingRoute";
import { putRouteStatusCancel } from "../../../store/transactions/thunk/route/putStatusCancelRoute";
import { putRouteStatusStart } from "../../../store/transactions/thunk/route/putStatusStartRoute";
import { deleteFiles } from "../../../store/transactions/thunk/filesRoute/delete";
import { postFiles } from "../../../store/transactions/thunk/filesRoute/post";
import { useCanView } from "../../../config/hook/UserPermissions";
import { getRouteIdDPEnd } from "../../../store/transactions/thunk/route/getDPEndAll";


const NewEdit = ({ setBtns }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("route");
    const { id } = useParams();
    const idRoute =   Number(id);
    const canView = useCanView();
    const [km, setKm] = useState(null)
    const [showMap, setShowMap] = useState(false);
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "put" })
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
    const [routes, setRoutes] = useState([]);
    const [mapLoad, setMapLoad] = useState(false);
    const [selectedDivision, setSelectedDivision] = useState("");
    const [selectedTonnelage, setSelectedTonnelage] = useState("");
    const [selectedProvider, setSelectedProvider] = useState("");
    const [kilometerEstimate, setKilometerEstimate] = useState(0);
    const [fuelEstimate, setFuelEstimate] = useState(0);
    const [transportType, setTransportType] = useState(0);
    const [fuelCost, setFuelCost] = useState(0);
    const [openModalLog, setOpenModalLog] = useState(false);
    const [kiloXGallon, setKiloXGallon] = useState(0);
    const [lisence, setLicense] = useState("");
    const [openOptions, setOpenOptions] = useState(false);
    const [openQuestion, setOpenQuestion] = useState({
        value: "",
        state: false
    });
    const [showGalery, setShowGalery] = useState(false);

    const [openModal, setOpenModal] = useState({
        transport: false,
        driver: false,
        formik: "",
    });

    const [tarift, setTarift] = useState({ 
        tonnelage: "",
        division: "",
        routeType: "",
        municipalyStart: "",
        municipalyEnd: "",
    });

    const [text, setText] = useState({
        transport: 0,
        valueTransport: "",
        driver: 0,
        valueDriver: ""
    });
    
    const current = useSelector(state => state.transactions.route.detail);

    const user = useSelector(state => state.auth.login.dataUser);
    const put = useSelector(state => state.transactions.route.put);
    const post = useSelector(state => state.transactions.route.post);
    const statusRoute = useSelector(state => state.transactions.route.putStatus);
    const deleteFile = useSelector(state => state.transactions.file.delete);
    const postFile = useSelector(state => state.transactions.file.post);
    const fuel = useSelector(state => state.masters.fuel);
    const transports = useSelector(state => state.masters.transport);
    const drivers = useSelector(state => state.masters.driver);
    const deliveryPointEnd = useSelector(state => state.transactions.route.deliveryPointEnd);
    const finishRoute = useSelector(state => state.transactions.route.putStatusFinish);
    const fakeShippingRoute = useSelector(state => state.transactions.route.putStatusFakeShipping);
    const cancelRoute = useSelector(state => state.transactions.route.putStatusCancel);
    const startRoute = useSelector(state => state.transactions.route.putStatusStart);
    const userData = JSON.parse(localStorage.getItem('userData'));
   

    const routeStatus = __(`routeStatus`, { returnObjects: true });
    const currentRouteStatus = get(current, 'data.idRouteStatus');

    const baseTransportOptions = map(transports?.data.data, ({ idTransport, comercialName, transportType, division }) => ({
        value: Number(idTransport),
        label: `${comercialName} - ${transportType} - ${division}`,
    }));
    const currentTransportId = id ? Number(get(current, 'data.idTransport')) : null;
    const hasCurrentInList = baseTransportOptions.some(t => t.value === currentTransportId);
    const optionsTransport = (currentTransportId && !hasCurrentInList)
        ? [{ value: currentTransportId, label: get(current, 'data.transportName', '') }, ...baseTransportOptions]
        : baseTransportOptions;

    const baseDriverOptions = map(drivers?.data.data, ({ idDriver, license, name }) => ({
        value: Number(idDriver),
        label: `${license} - ${name}`,
    }));
    const currentDriverId = id ? Number(get(current, 'data.idDriver')) : null;
    const hasCurrentDriverInList = baseDriverOptions.some(d => d.value === currentDriverId);
    const optionsDriver = (currentDriverId && !hasCurrentDriverInList)
        ? [{ value: currentDriverId, label: `${get(current, 'data.license')} - ${get(current, 'data.driverName')}` }, ...baseDriverOptions]
        : baseDriverOptions;

    const transportTypes = map(userData?.transportTypes, ({ idTransportType, description }) => ({
            value: idTransportType,
            label: description,   
        }));

    const routesTypes = map(userData?.routesTypes, ({ idRouteType, description }) => ({
                value: idRouteType,
                label: description,
        }));

    useEffect(() => {
        getDataAll();
    }, [])

    const getDataAll= () => {
        let Screen = "RUTAS"
        dispatch(getLog({page: 1, docId: Number(id), screen: String(Screen)}))
        dispatch(getFuel({ page: 1, Export: true }));
        dispatch(getRouteId(Number(id)));  
    };

    useEffect(() => {
        if (get(current, "isSuccess")) {
            const providerId = get(current, "data.idProvider");

            // Actualizamos el estado general
            setSelectedProvider(providerId);
            dispatch(getDeliveryPointRoute(id));
            setSelectedDivision(get(current, "data.divisionId"));
            setSelectedTonnelage(get(current, "data.idTransportType"));
            setText((prevText) => ({ ...prevText, transport: get(current, "data.idTransport"), valueTransport: `${get(current, "data.comercialName")} | ${get(current, "data.transportType")} | ${get(current, "data.divisionName")}` }));
            setText((prevText) => ({ ...prevText, driver: get(current, "data.idDriver"), valueDriver: `${get(current, "data.license")} | ${get(current, "data.driverName")}` }));
            setLicense(get(current, "data.license"));
            setTransportType(get(current, "data.idTransport"));
            setFuelEstimate(get(current, "data.fuelCost"));
            setKiloXGallon(get(current, "data.kiloXGallon"));
            setKilometerEstimate(get(current, "data.kilometersEstimate"));
            setFuelCost(current, "data.priceFuel");

            let body = {
                customerId: get(current, "data.customerId"),
                divisionId: get(current, "data.divisionId"),
                muniId: get(current, "data.idMuniStart"),
            }
            dispatch(getRouteIdDPEnd(body));
            setTarift({
                tonnelage: get(current, "data.transportType", ""),
                division: get(current, "data.divisionName", ""),
                routeType: get(current, "data.routeTypeName", ""),
                municipalyStart: get(current, "data.municipalityStartName", ""),
                municipalyEnd: get(current, "data.municipalityEndName", ""),
            });
        }

    }, [current]);

        const deliveryPointsEnd = map(deliveryPointEnd?.data, ({ idDeliveryPoint, deliveryName }) => ({
            value: idDeliveryPoint,
            label: `${deliveryName}`,
        }));

    useEffect(() => {
        if (selectedProvider > 0) {
            dispatch(getDriver({ idProvider: selectedProvider, isActive: true, Export: true }));
        } else {
            dispatch(getDriverClear());
        }
    }, [selectedProvider]);

    useEffect(() => {
        if (selectedTonnelage) {
            dispatch(getTransport({ idTransportType: selectedTonnelage, isActive: true, Export: true }));
        }
    }, [selectedTonnelage]);

    useEffect(() => {
      if (routes.length > 0) {
        kilometers(routes);
      }
    }, [routes]);

    const kilometers = async ( coords ) => {

        let { lat: originLat, lng: originLng } = coords[0].location;
        let { lat: destinationLat, lng: destinationLng } = coords[1].location;
        
        let origin = { latitude: originLat, longitude: originLng }; 
        let destination = { latitude: destinationLat, longitude: destinationLng };

        const kms = await calculateKilometers(origin, destination)
        const retorno = await calculateKilometers(destination, origin)
        let totalKm = Number(retorno) + Number(kms);
        setKilometerEstimate(totalKm);
    };

    useEffect(() => {

        if(transportType > 0 && Object.keys(transports.data) && get(transports, "isSuccess") && get(fuel, "isSuccess") && Object.keys(fuel.data)){

            // Convierte dateToRoute a una fecha para la comparación
            const dateToRoute = new Date(current.data.dateToRoute);
            // Filtramos las entradas que cumplen con el rango de fecha y tipo de combustible
            const resultados = get(fuel.data, "data").filter((registro) => {
                const fechaInicio = new Date(registro.startDate);
                const fechaFin = new Date(registro.endDate);

            // Verificamos que dateToRoute esté dentro del rango y que coincida el tipo de combustible
                return (
                    dateToRoute >= fechaInicio &&
                    dateToRoute <= fechaFin &&
                    registro.fuelType === transportType
                );
            });
      
            if (resultados.length > 0) {
                setFuelCost(resultados[0].price);
                fuelcostRoute(resultados[0].price);
            } else {
                // console.log("no match")
                setFuelCost(null); // o un valor predeterminado como 0
            }
      }
    }, [transportType, transports, fuel]);

    const fuelcostRoute = (fuel) => {

        if (kilometerEstimate > 0 && fuel > 0 && kiloXGallon > 0) {
            const totalGallons = kilometerEstimate / kiloXGallon;
            const fuelEstimatesRoute = totalGallons * fuel;
            setFuelEstimate(fuelEstimatesRoute);
        }
    };
    
    const orders = useSelector(state => state.transactions.route.orderAll);

    const reload = () => {dispatch(getRouteId( id ));}

    const getMapRoutes = async () => {
        setMapLoad(true);

        const deliveryPoints = get(current, "data.routeDeliveryPoints", []);
        let idCounter = 1;
        const routesOrder = deliveryPoints
            .map((point) => {
                const lat = parseFloat(get(point, "latitude"));
                const lng = parseFloat(get(point, "longitude"));

                // Verificar si las coordenadas son válidas (ni NaN ni null)
                if (!isNaN(lat) && !isNaN(lng)) {
                    return {
                        location: {
                            id: idCounter++, // Asignar ID único y aumentar el contador
                            lat: lat,
                            lng: lng
                        }
                    };
                }
                return null; // Retornamos null si no es válido, luego lo filtramos
            })
            .filter(route => route !== null); 
        setRoutes(routesOrder);
        setMapLoad(false);
    };

    const handleSubmit = (modal, formik) => {
        if ( modal === 'transport') {
            setText((prevText) => ({ ...prevText, driver: "", valueDriver:""}));
        }
        setOpenModal((prev) => ({ ...prev, [modal]: true, formik: formik }));
    };
    
    const handleCallback = (value, indice) => {
        setOpenModal((prev) => ({ ...prev, driver: false, transport: false }))
        if (indice === 'driver') {
            openModal.formik.setFieldValue("idDriver", value.idDriver);
            setText((prevText) => ({ ...prevText, driver: value.idDriver, valueDriver: `${value.license} | ${value.name}` }));
            setLicense(value.license);
        } else if (indice === 'transport') {
            openModal.formik.setFieldValue("idTransport", value.idTransport);
            setText((prevText) => ({ ...prevText, transport: value.idTransport, valueTransport: `${value.comercialName} | ${value.transportType} | ${value.division}` }));
            setKiloXGallon(value.kiloXGallon);
            setTransportType(value.idTransportFuelType);
            setSelectedProvider(value.idProvider);
        }
    };
    
    const HandleModification = (documentName) => {
        dispatch(deleteFiles(documentName));
    };

    const HandleUploadFile = (file) => {
        dispatch(postFiles(file));
    };

    const getColorById = (id) => {
        switch (id) {
            case 1:
                return '#03BE06';
            case 2:
                return '#E320C2';
            case 3:
                return '#355CEC';
            case 4:
                return '#13C8BB';
            case 5:
                return '#ff0000';
            case 6:
                return '#E32020';
            case 7:
                return '#ECAF35';
            default:
                return '#5D67DE';
        }
    };

    const color = getColorById(currentRouteStatus);

    useEffect(() => {
        if (get(current, "isSuccess")) {
            getMapRoutes();
        }
    }, [get(current, "isSuccess"), get(orders, "isSuccess")])


    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }
    const closeNoti = (e) => {
        setShowNoti(e)
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                type: "error",
                title: "Uno o más errores de validación han ocurrido.",
                subtitle: (<li>{` ${get(err, "ErrorMessage")}`}</li>),
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
        }
    }

    useEffect(() => {
        if (get(put, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
        if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put"); }
        if (get(post, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "post" }) }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post"); }
        if (get(deleteFile, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
        if (get(postFile, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "post" }) }
        if (get(statusRoute, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" })}
        if (get(statusRoute, "isReject", false)) { setError(get(statusRoute, "error", {}), "put"); }
        if (get(finishRoute, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
        if (get(finishRoute, "isReject", false)) { setError(get(finishRoute, "error", {}), "put"); }
        if (get(fakeShippingRoute, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
        if (get(fakeShippingRoute, "isReject", false)) { setError(get(fakeShippingRoute, "error", {}), "put"); }
        if (get(cancelRoute, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
        if (get(cancelRoute, "isReject", false)) { setError(get(cancelRoute, "error", {}), "put"); }
        if (get(startRoute, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
        if (get(startRoute, "isReject", false)) { setError(get(startRoute, "error", {}), "put"); }
    }, [put, post, deleteFile, postFile, statusRoute, finishRoute, fakeShippingRoute, cancelRoute, startRoute])

    const onSubmitStatus = () => {

        if (openQuestion.value === 'finalizar') {

            const body = {
                idRoute: Number(id),
                customerId: `${get(current, "data.customerId")}`,
                idStartDP: Number(get(current, "data.idMuniStart")),
                idEndDP: Number(get(current, "data.idMuniEnd")),
                divisionId: Number(get(current, "data.divisionId")),
                idTransportType: Number(get(current, "data.idTransportType")),
                idRouteType: Number(get(current, "data.idRouteType")),
                idProvider: Number(get(current, "data.idProvider")),
            }

            dispatch(putRouteStatusFinish(body));
            setOpenQuestion(prev => ({ ...prev, state: false, value: '' }))

        } else if (openQuestion.value === 'liquidar') {

            const body = {
                idRoute: Number(id),
                statusId: Number(7),
                userId: Number(get(user, "idUser")),
            }
            dispatch(putRouteStatus(body));
            setOpenQuestion(prev => ({ ...prev, state: false, value: '' }))
            // window.location.reload();
        } else if (openQuestion.value === 'iniciar') {
            if (get(current, "data.idDriver") === 0 || get(current, "data.idTransport") === 0) {
                setAlert({
                    open: true,
                    title: "Error de Validación",
                    subtitle: (<ul> • Debe de seleccionar Transporte/Conductor para iniciar la ruta.</ul>),
                    type: "error",
                    btn: __(`${module}.actions.close`),
                    func: closeAlert
                  })
                setOpenQuestion(prev => ({ ...prev, state: false, value: '' }))
            } else {
                dispatch(putRouteStatusStart({ idRoute: Number(id) }));
                setOpenQuestion(prev => ({ ...prev, state: false, value: '' }))
            }
        } else if (openQuestion.value === 'cancelar'){

                dispatch(putRouteStatusCancel({ idRoute: Number(id) }));
                setOpenQuestion(prev => ({ ...prev, state: false, value: '' }))

        } else if (openQuestion.value === 'fletefalso'){

            const body = {
                idRoute: Number(idRoute),
                comments: get(current, "data.comments", ""),
                dateToRoute: moment(get(current, "data.dateToRoute")),
                idTransport: 1,
                idDriver: 1,
                idUser: 1,
                idRouteStatus: 7,
                idStartDP: Number(get(current, "data.idMuniStart")),
                idEndDP:  Number(get(current, "data.idMuniEnd")),
                customerId: `${get(current, "data.customerId")}`,
                kilometersEstimate: 1,
                fuelCost: 1,
                fuelGallons: 1,
                idTransportType: get(current, "data.idTransportType"),
                divisionId: get(current, "data.divisionId"),
                idRouteType: get(current, "data.idRouteType"),
                idProvider: get(current, "data.idProvider"),
                isFakeShipping: true,
            }

            dispatch(putRouteStatusFakeShipping(body));
            setOpenQuestion(prev => ({ ...prev, state: false, value: '' }))
            
        }
    }

    const onSubmit = (values) => {
        if (canView("TRANSACCIONES/RUTAS", "update")) {
            const body = {
                idRoute: idRoute,
                idTransport: Number(text.transport),
                idDriver: Number(text.driver),
                comments : get(values, "comments"),
                kilometersEstimate: kilometerEstimate, 
                dateToRoute: get(values, "dateToRoute"),
                idDeliveryPoint: Number(get(values, "idEndDP")),
                idTransportType: Number(get(values, "tonnelage"))
            }
            dispatch(putRoute(body));
        } else {
            setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para actualizar la ruta.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    };

    const initialValues = {
        isActive: get(current, "data.isActive", true),
        idRoute: get(current, "data.idRoute"),
        routeName: get(current, "data.routeName", ""),
        clients: `${get(current, "data.customerId")} - ${get(current, "data.customerName")}`,
        idRouteStatus: get(find(routeStatus, ({ value }) => value === get(current, "data.idRouteStatus", 1)), "value"),
        routeStatus: get(current,  "data.routeStatus"),
        idStartDP: `${get(current, "data.startDpDescription")}`,
        idEndDP:  Number(get(current, "data.idEndDP")),
        idTransport: get(current, "data.idTransport"),
        idDriver: get(current, "data.idDriver"),
        dateToRoute: moment(get(current, "data.dateToRoute")),
        comments: get(current, "data.comments", ""),
        idUser: get(user, "idUser"),
        division: get(current, "data.divisionName"),
        tonnelage: get(current, "data.idTransportType"),
        kilometersReal: `${get(current, "kilometersEstimate", 0.0)} Km`,
        idRouteType: get(current, "data.idRouteType"), 
    }

    const getQuestionTitle = () => {
        switch (openQuestion.value) {
            case "iniciar":
                return __("alert.routeStart"); 
            case "finalizar":
                return __("alert.routeEnd"); 
            case "liquidar":
                return __("alert.routeLiquide");
            case "cancelar":
                return __("alert.routeCancel");
            case "fletefalso":
                return __("alert.routeFalseFlete");

        }
    };


    const getQuestionDetail= () => {
        switch (openQuestion.value) {
            case 'iniciar':
                return __("alert.routeStartDetail"); 
            case 'finalizar':
                return __("alert.routeEndDetail"); 
            case 'liquidar':
                return __("alert.routeLiquideDetail");
                case "cancelar":
                return __("alert.routeCancelDetail");
            case "fletefalso":
                return __("alert.routeFalseFleteDetail");
        }
    };  
    
    const handleTonnelageChange = (formik, value) => {
        formik.setFieldValue("tonnelage", value);
        formik.setFieldValue("idTransport", 0);
        formik.setFieldValue("idDriver", 0);
        setSelectedTonnelage(value);
        setText((prevText) => ({ ...prevText, transport: "", valueTransport: "",  driver: "", valueDriver:""}))
    };

    useEffect(() => {
        setBtns(
            <Stack className='mr-6' direction="row" spacing={2} justifyContent="flex-end" width="100%">
                <Button
                    className="w-[150px] min-w-[150px]"
                    variant="outlined"
                    color="secondary"
                    startIcon={< HistoryIcon/>}
                    onClick={() => {
                        if (canView("TRANSACCIONES/RUTAS/LOGS", "watch")) {
                            setOpenModalLog(true)
                        } else {
                            setAlert({
                                open: true,
                                title: "Permiso Denegado.",
                                subtitle: (<ul> • No tienes permiso para ver las modificaciones en rutas.</ul>),
                                type: "error",
                                btn: __(`${module}.actions.close`),
                                func: closeAlert
                            })
                        }
                    }}
                    // disabled={get(put, "isLoading")}
                    >
                    Ver Cambios
                </Button>
                <Button className='w-[100px] min-w-[100px]' variant='text' color="secondary"  onClick={() => {
                    if (canView("TRANSACCIONES/RUTAS/ADJUNTOS", "watch")) {
                        setShowGalery(true)
                    } else {
                        setAlert({
                            open: true,
                            title: "Permiso Denegado.",
                            subtitle: (<ul> • No tienes permiso para ver los adjuntos de la ruta.</ul>),
                            type: "error",
                            btn: __(`${module}.actions.close`),
                            func: closeAlert
                        })
                    }
                }} disabled={get(put, "isLoading")} >
                    <div className='whitespace-nowrap'>Ver Adjuntos</div>
                </Button>
                {get(current, "data.idRouteStatus") === 4 || get(current, "data.idRouteStatus") === 8 ? (
                    <Button 
                        className='w-[100px] min-w-[100px]' 
                        variant='contained' 
                        startIcon={<StopIcon/>}
                        color="error" 
                        onClick={() => { 
                            if (canView("TRANSACCIONES/RUTAS/FINALIZAR", "update")) {
                                setOpenQuestion(prev => ({ ...prev, state: true, value: 'finalizar' })) 
                            } else {
                                setAlert({
                                    open: true,
                                    title: "Permiso Denegado.",
                                    subtitle: (<ul> • No tienes permiso para finalizar la ruta.</ul>),
                                    type: "error",
                                    btn: __(`${module}.actions.close`),
                                    func: closeAlert
                                })
                            }
                        }} disabled={get(current, "data.idRouteStatus") === 5 || get(current, "data.idRouteStatus") === 7 ? true : false}
                    >
                        Finalizar
                    </Button>
                ) : (
                    <Button 
                        className='w-[100px] min-w-[100px]' 
                        variant='contained' 
                        startIcon={<PlayArrowIcon/>}
                        sx={{ backgroundColor: '#4CAF50', color: 'white', '&:hover': { backgroundColor: '#45A049' } }} 
                        onClick={() => { 
                            if (canView("TRANSACCIONES/RUTAS/INICIAR", "update")) {
                                setOpenQuestion(prev => ({ ...prev, state: true, value: 'iniciar' })) 
                            } else {
                                setAlert({
                                    open: true,
                                    title: "Permiso Denegado.",
                                    subtitle: (<ul> • No tienes permiso para iniciar la ruta.</ul>),
                                    type: "error",
                                    btn: __(`${module}.actions.close`),
                                    func: closeAlert
                                })
                            }
                        }} disabled={get(current, "data.idRouteStatus") === 1 || get(current, "data.idRouteStatus") === 2 || get(current, "data.idRouteStatus") === 3 ? false : true}
                    >
                        Iniciar
                    </Button>
                )}
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button
                            className="w-[125px] min-w-[125px]"
                            variant="outlined"
                            color="secondary"
                            startIcon={<MoreVertIcon />}
                            onClick={() => {
                                if (canView("TRANSACCIONES/RUTAS/ACCIONES", "update")) {
                                    setOpenOptions(true);
                                } else {
                                    setAlert({
                                        open: true,
                                        title: "Permiso Denegado.",
                                        subtitle: (<ul> • No tienes permiso para modificar el estado de la ruta.</ul>),
                                        type: "error",
                                        btn: __(`${module}.actions.close`),
                                        func: closeAlert
                                    })
                                }
                            }}
                        >
                            Acciones
                        </Button>
                    </DropdownMenuTrigger>
                        <DropdownMenuContent className="bg-white shadow-md rounded-md p-2 w-48 z-50">
                            <DropdownMenuItem className="flex items-center gap-2 text-blue-800 hover:bg-blue-100 p-2 cursor-pointer" onClick={() => {
                                if (canView("TRANSACCIONES/RUTAS/FLETEFALSO", "update")) {
                                    setOpenQuestion(prev => ({ ...prev, state: true, value: 'fletefalso' })) 
                                } else {
                                    setAlert({
                                        open: true,
                                        title: "Permiso Denegado.",
                                        subtitle: (<ul> • No tienes permiso para colocar la ruta como flete falso.</ul>),
                                        type: "error",
                                        btn: __(`${module}.actions.close`),
                                        func: closeAlert
                                    })
                                }
                            }}>
                                <LocalShippingOutlinedIcon size={16} className="text-blue-500" /> Flete Falso
                            </DropdownMenuItem>
                            <DropdownMenuItem className="flex items-center gap-2 text-red-600 hover:bg-red-100 p-2 cursor-pointer" onClick={() => {
                                if (canView("TRANSACCIONES/RUTAS/CANCELAR", "update")) {
                                    setOpenQuestion(prev => ({ ...prev, state: true, value: 'cancelar' })) 
                                } else {
                                    setAlert({
                                        open: true,
                                        title: "Permiso Denegado.",
                                        subtitle: (<ul> • No tienes permiso para cancelar la ruta.</ul>),
                                        type: "error",
                                        btn: __(`${module}.actions.close`),
                                        func: closeAlert
                                    })
                                }
                            }}>
                                <CancelOutlinedIcon  size={16} className="text-red-500" /> Cancelar
                            </DropdownMenuItem>
                            <DropdownMenuItem className="flex items-center gap-2 text-yellow-600 hover:bg-yellow-100 p-2 cursor-pointer" onClick={() => {
                                if (canView("TRANSACCIONES/RUTAS/LIQUIDAR", "update")) {
                                    setOpenQuestion(prev => ({ ...prev, state: true, value: 'liquidar' })) 
                                } else {
                                    setAlert({
                                        open: true,
                                        title: "Permiso Denegado.",
                                        subtitle: (<ul> • No tienes permiso para liquidar la ruta.</ul>),
                                        type: "error",
                                        btn: __(`${module}.actions.close`),
                                        func: closeAlert
                                    })
                                }
                            }}>
                                <AttachMoneyIcon size={16} className="text-yellow-500" /> Liquidar
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                </DropdownMenu>
                <LoadingButton disabled={get(current, "data.idRouteStatus") === 1 || get(current, "data.idRouteStatus") === 2 || get(current, "data.idRouteStatus") === 3 ? false : true} className='w-[100px] min-w-[100px]' startIcon={<SaveIcon/>} variant="contained" color="secondary" type="submit" form="form-route" loading={get(put, "isLoading")}>{__(`action.save`)}</LoadingButton>
                <Button className='w-[100px] min-w-[100px]' variant='outlined' color="secondary" onClick={() => navigate("/transactions/routes")} disabled={get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
            </Stack>
        )
    }, [get(put, "isLoading"), get(current, "data.idRouteStatus", 1), get(current, "isLoading")]);

    return (
        <div>
            {get(deliveryPointEnd, "isLoading", false) || get(current, "isLoading", false) ? (
                <Skeleton />
            ) : get(deliveryPointsEnd, "length", 0) === 0 ? (
                <MissingTariffAlert
                    startMunicipality={tarift.municipalyStart}
                    endMunicipality={tarift.municipalyEnd} 
                    division={tarift.division}
                    tonnage={tarift.tonnelage}
                    routeType={tarift.routeType}
                />
            ) : (
                    <Formik initialValues={initialValues} validationSchema={validator(__)} onSubmit={onSubmit}>
                        {formik => (
                            <form id="form-route" onSubmit={get(formik, "handleSubmit")}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} lg={6}>
                                        <Paper className='mt-4' >
                                            <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                                                <Typography component="h4" variant="h4">{`${__(`labels.1`)} - ${id}`}</Typography>
                                                <InputTextDetail
                                                    name={"routeStatus"}
                                                    formik={formik}
                                                    label=""
                                                    placeholder=""
                                                    disabled={true}
                                                    fullWidth={false}
                                                    sx={{ "fieldset": { borderColor: `${color} !important` }, "& .Mui-disabled": { "-webkit-text-fill-color": `${color} !important` } }}
                                                />
                                            </Stack>
                                            <Divider />
                                            <Box className='p-4' >
                                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                                <Grid item xs={12}>
                                                        <InputText
                                                            formik={formik}
                                                            name="routeName"
                                                            label={__(`form.routeName.label`)}
                                                            placeholder={__(`form.routeName.placeholder`)}
                                                            disabled
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <InputTextDetail
                                                            name="clients"
                                                            formik={formik}
                                                            label={__(`form.clients.label`)}
                                                            placeholder={__(`form.clients.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Autocomplete
                                                            formik={formik}
                                                            name="idRouteType"
                                                            label={__(`form.idRouteType.label`)}
                                                            placeholder={__(`form.idRouteType.placeholder`)}
                                                            disabled
                                                            options={routesTypes}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <InputTextDetail
                                                            name={"idStartDP"}
                                                            formik={formik}
                                                            label={__(`form.idStartDP.label`)}
                                                            placeholder={__(`form.idStartDP.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(put, "isLoading", false) || get(put, "isLoading", false)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Autocomplete
                                                            name={"idEndDP"}
                                                            formik={formik}
                                                            label={__(`form.idEndDP.label`)}
                                                            placeholder={__(`form.idEndDP.placeholder`)}
                                                            options={deliveryPointsEnd}
                                                            loading={get(current, "isLoading")}
                                                            disableClear={true}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <DatePickerUi
                                                            formik={formik}
                                                            name="dateToRoute"
                                                            label={__(`form.dateToRoute.label`)}
                                                            placeholder={__(`form.dateToRoute.placeholder`)}
                                                            disabled={false}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <InputTextDetail
                                                            name="division"
                                                            formik={formik}
                                                            label={__(`form.division.label`)}
                                                            placeholder={__(`form.division.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Autocomplete
                                                            name="tonnelage"
                                                            formik={formik}
                                                            label={__(`form.tonnelage.label`)}
                                                            placeholder={__(`form.tonnelage.placeholder`)}
                                                            options={transportTypes}
                                                            onChange={(event, value) => handleTonnelageChange(formik, value.value)} 
                                                            disableClear={true}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography component="h5" variant="h5" color="text.lite">{__(`labels.3`)}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <InputGroup
                                                            name="idTransport"
                                                            formik={formik}
                                                            label={__(`form.idTransport.label`)}
                                                            placeholder={__(`form.idTransport.placeholder`)}
                                                            options={optionsTransport}
                                                            onClick={()=> handleSubmit('transport', formik)}
                                                            selectedId={Number(formik.values.idTransport)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <InputGroup
                                                            name={"idDriver"}
                                                            formik={formik}
                                                            label={__(`form.idDriver.label`)}
                                                            placeholder={__(`form.idDriver.placeholder`)}
                                                            options={optionsDriver}
                                                            onClick={() => text.transport ? handleSubmit('driver', formik) : ""}
                                                            selectedId ={Number(formik.values.idDriver)} 
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography component="h5" variant="h5" color="text.lite">{__(`labels.3`)}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <InputText
                                                            formik={formik}
                                                            name="comments"
                                                            label={__(`form.comments.label`)}
                                                            disabled={get(current, "isLoading", false) || get(put, "isLoading", false) || get(put, "isLoading", false)}
                                                            multiline
                                                            rows={3}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <InputTextDetail
                                                            formik={formik}
                                                            name="kilometersReal"
                                                            label={__(`form.kilometersReal.label`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Paper>
                                    </Grid>

                                    <Grid item xs={12} lg={6}>
                                        <Paper className='mt-4 p-4 flex h-full flex-col' sx={{ height: 500 }}>
                                            <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                                                {current &&
                                                    <>
                                                        <Typography component="h4" variant="h4">
                                                            <Speed /> {get(current, "data.kilometersEstimate")?.toFixed(2) ? get(current, "data.kilometersEstimate") : (kilometerEstimate)?.toFixed(1) || "0.0" } Km
                                                        </Typography>
                                                        <Typography component="h4" variant="h4">
                                                            <LocalGasStation/> ${(fuelEstimate)?.toFixed(2) || "0.00"}
                                                        </Typography>
                                                    </>
                                                }
                                            </Stack>
                                            <Map loading={mapLoad} routes={routes} setKm={setKm} __={__} />
                                        </Paper>
                                        <Paper className='mt-4 p-4 flex h-full flex-col' sx={{ height: 450 }}>
                                            <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                                                <Typography component="h4" variant="h4">{__(`labels.5`)}</Typography>
                                            </Stack>
                                            <Graf />
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                )}
            <TransportModal
                __={__}
                open={openModal.transport}
                division = {selectedDivision}
                tonnelage = {selectedTonnelage}
                close={() => setOpenModal((prev) => ({ ...prev, transport: false}))}
                callback={(value) => handleCallback (value, 'transport')}
                showNoti={showNoti}
                setShowNoti={setShowNoti}
                alert={alert}
                setAlert={setAlert}
            />
            <DriverModal
                __={__}
                open={openModal.driver}
                id={selectedProvider}
                close={() => setOpenModal((prev) => ({ ...prev, driver: false }))}
                callback={(value) => handleCallback (value, 'driver')}
            />
            <Notification __={__} showNoti={showNoti} setShowNoti={closeNoti} />
            <LogsModal
                __={__}
                open={openModalLog}
                close={() => setOpenModalLog(false)}
            />
            <Alert
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
            <RoutesModal
                __={__}
                open={showMap}
                close={() => setShowMap(false)}
            />
            <FilesModal
                __={__}
                open={showGalery}
                close={() => setShowGalery(false)}
                onModification = {HandleModification}
                onUploadFile = {HandleUploadFile}
            />
            <Question
                title={getQuestionTitle()}
                detail={getQuestionDetail()}
                onSuccess={onSubmitStatus}
                onCancel={() => setOpenQuestion(prev => ({ ...prev, state: false }))}
                open={openQuestion.state}
            />
        </div>

    )
}

export default NewEdit